import { useEffect } from "react";
import { proxy } from "valtio";
import { AlternativeProductGroup } from "../../../hooks/useAlternativeProducts";
import { useBottomMenu } from "../../../hooks/useBottomMenu";
import { BottomMenuPaths } from "../../bottom-menu/paths";

interface IAlternativeProductsPanelState {
	selectedAlternativeProductGroup: AlternativeProductGroup | undefined;
}

const state = proxy<IAlternativeProductsPanelState>({
	selectedAlternativeProductGroup: undefined,
});

function setSelectedAlternativeProductGroup(group: AlternativeProductGroup | undefined) {
	state.selectedAlternativeProductGroup = group;
}

export const useSelectedAlternativeProductGroupState = () => {
	const { currentPath } = useBottomMenu();

	// Clear the selected alternative product if no alternative products shown in bottom menu
	useEffect(() => {
		if (currentPath !== BottomMenuPaths.AlternativeProducts) {
			setSelectedAlternativeProductGroup(undefined);
		}
	}, [currentPath]);

	return [state.selectedAlternativeProductGroup, setSelectedAlternativeProductGroup] as [
		AlternativeProductGroup | undefined,
		(group: AlternativeProductGroup | undefined) => void,
	];
};
